import React from "react";
import { NavLink } from "react-router-dom";
import "./BottomNavigation.css";

const BottomNavigation = () => {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" className="nav-item"><img src="/images/icon_home.png" width="32" alt="HOME OF CULT" /></NavLink>
      <NavLink to="/leaderboard" className="nav-item"><img src="/images/icon_leaderboard.png" width="32" alt="THEY ENLIGHTENED"/></NavLink>
      <NavLink to="/acceptCult" className="nav-item"><img src="/images/icon_mint.png" width="32" alt="ACCEPT THE CULT" /></NavLink>
    </nav>
  );
};

export default BottomNavigation;
